/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';


export default (units) =>
{
  let state = new Immutable.Map();

  for (const unit of units)
  {
    state = state.set(unit.type, unit);
  }

  return state;

}
